// extracted by mini-css-extract-plugin
module.exports = {"content":"UpdateEdgeConfigConfirmationModal_content__aRWBG","pinkText":"UpdateEdgeConfigConfirmationModal_pinkText__1OWv2","bold":"UpdateEdgeConfigConfirmationModal_bold__2jGP2"};